<main>

  <AccountPage />
  <UsersPage  />
  <RolesPage  />
  
  <!-- <DevicePage /> -->
  <ListsCollectionPage />
  
  <!-- <ListDefPage /> -->
  <ListNewPage />

  <!-- <FormFieldDialogs /> -->
  <RecordDefsCollectionPage />
  <RecordDefNewPage />
  <RecordDefPage />
  
  <ProcessDefsCollectionPage />
  <!-- <ProcessDefPage /> -->
  <ProcessDefNewPage />
  
  <MetricDefsPage />
  
  <DashboardsPage />
  
  <ReportDefsCollectionPage />
  <ReportDefPage />
  
  <ConnectorsCollectionPage />
  <ConnectorPage />
  
  <Body />
  <!-- {#if !isLogged}
    <h3>Conectandose a Tremé ...</h3>
  {:else}

    {#if $page.to === '#/'}
      <h3>Configuradores</h3>
      <p>
        <a href="#/conectores">Conectores</a>
      </p>
      <p>
        <a href="#/reportes">Reportes</a>
      </p>
    {/if}
  
    {#if $page.to === '#conectores'}
      <p>
        <a href="#/">Studio</a>
        &gt;
        <a href="{$page.to}">Conectores</a>
      </p>
      <ConnectorAutoconf />
    {/if}

    {$page.to}
    {JSON.stringify($page.params)}

  {/if} -->

</main>

<svelte:window on:hashchange={() => {changePage();}}/>

<script>
  import { onMount } from 'svelte'
  import API from '@/api'
  import { iDB } from '@/storage/idb'
  import { page, navigate } from '@/states'
  import { login } from './login'
  import { customizedTheme } from './customized-theme'

  import { Account } from '@/models/accounts'
  import { User } from '@/models/users'

  // Legacy pages 
  import Body from '@/pages/legacy/Body.svelte'
  
  import AccountPage from '@/pages/legacy/AccountPage.svelte'
  
  import UsersPage from '@/pages/legacy/UsersPage.svelte'
  
  import RolesPage from '@/pages/legacy/RolesPage.svelte'

  // import DevicePage from '@/pages/legacy/DevicePage.svelte'

  import ListsCollectionPage from '@/pages/legacy/ListsCollectionPage.svelte'
  //import ListDefPage from '@/pages/legacy/ListDefPage.svelte'
  import ListNewPage from '@/pages/legacy/ListNewPage.svelte'
  
  //import FormFieldDialogs from '@/pages/legacy/FormFieldDialogs.svelte'
  import RecordDefNewPage from '@/pages/record-defs/RecordDefNewPage.svelte'
  import RecordDefPage from '@/pages/record-defs/RecordDefPage.svelte'
  import RecordDefsCollectionPage from '@/pages/record-defs/RecordDefsCollectionPage.svelte'
  
  import ProcessDefsCollectionPage from '@/pages/legacy/ProcessDefsCollectionPage.svelte'
  //import ProcessDefPage from '@/pages/legacy/ProcessDefPage.svelte'
  import ProcessDefNewPage from '@/pages/legacy/ProcessDefNewPage.svelte'

  import MetricDefsPage from '@/pages/legacy/MetricDefsPage.svelte'
  import DashboardsPage from '@/pages/legacy/DashboardsPage.svelte'

  import ConnectorsCollectionPage from '@/pages/connectors/ConnectorsCollectionPage.svelte'
  import ConnectorPage from '@/pages/connectors/ConnectorPage.svelte'

  // Svelte components
  import ReportDefsCollectionPage from '@/pages/reports/ReportDefsCollectionPage.svelte'
  import ReportDefPage from '@/pages/reports/ReportDefPage.svelte'
  
  let isLogged = false ;

  customizedTheme();
  
  // restore active session from LocalStorage
  // if it already exists
  import { Session } from '@/models'
  Session.restore();
  API.restoreState();

  window.Idb = iDB({
    name: 'studio',
    store: 'key-value-store',
    version: 20
  }); 
  Idb.open().then(() => {
    console.log("App iDB opened=", Idb);
  })
  window.Account = Account;
  window.User = User;
  
  onMount(() => {
  
    
    window.location = "#";
    //isLogged = await login('testadmin@treme.io', 'admin');
    // isLogged = await login('sgc@elrenuevo.com.ar', '1234');
    window.location = "#/iniciar";

  })

  function changePage() {
    // respond to the 'hashchange' event and
    // extract page and params from location url
    const parts = location.hash.split('?')
    const page = parts[0];
    const qs = parts.length > 1 ? parts[1] : null;
    console.log('App: changePage:', page, qs)
    // navigate(page, qs);
  }  
</script>

<style>
  main {
    font-size: 16px;
    padding: 1rem;
    margin: 0;
  }
</style>